import { useEffect, useRef, useState } from "react";
import { useSnapshot } from "valtio";
import { taskStore } from "../mytasks/task-store";
import Taskapi, { Task } from "../mytasks/tasks-api";
import { getPayload } from "../mytasks/tasks-static-data";
import { bookingsStore, configStore, entityStore, multiSelectListStore } from "../state/CommonState";
import MonApi, { GET_BOOKINGDSR_BY_FILTER_URI, GET_PENDING_MYACTIONS_URI, REMOVE_MYACTIONS_BY_BOOKING_NUMBER_AND_STATUS_URI, UPDATE_BOOKING_CANCELLED_URI } from '../state/mongo-api';
import CartingOrderApi from "../state/cartingorder-api";

export function AgMultiSelectWithCheckBoxes({
  label,
  storeKey,
  callback,
  withAllShortcut,
}) {
  const snap = useSnapshot(multiSelectListStore);
  const wrapperRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!expanded) return;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setExpanded(false);
        callback && callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  return (
    <div className="field" ref={wrapperRef}>
      <label className="label is-small" style={{ marginBottom: "0px" }}>
        {label}
      </label>

      <div className="control">
        <div className="ag-multiselect select is-small">
          <div
            className="selectBox"
            onClick={() => {
              setExpanded(!expanded);
              callback();
            }}
          >
            <select>
              <option>
                {(() => {
                  let selectedLength =
                    snap.selectList[storeKey]?.filter((e) => e.checked).length;

                  return selectedLength === snap.selectList[storeKey]?.length
                    ? "ALL"
                    : `${selectedLength} selected`;
                })()}
              </option>
            </select>

            <div className="overSelect"></div>
          </div>

          {expanded && (
            <div className="ag-multiselect-dropdown">
              {withAllShortcut && (
                <>
                  <label className="checkbox" style={{ fontWeight: 900, margin: "5px" }}>
                    <input
                      type="checkbox"
                      checked={snap.selectList[storeKey]?.every((e) => e.checked)}
                      onChange={(e) => {
                        multiSelectListStore.selectList[storeKey] =
                          snap.selectList[storeKey]?.map((item) => ({
                            ...item,
                            checked: e.target.checked,
                          }));
                      }}
                      style={{ marginRight: "7px" }}
                    />
                    All
                  </label>
                  <hr style={{ marginBottom: "5px", marginTop: "5px" }} />
                </>
              )}

              {snap.selectList[storeKey]?.map(({ id, name, checked, scacCode }) => (
                <label key={id} className="checkbox" style={{ margin: "5px" }}>
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => {
                      multiSelectListStore.selectList[storeKey] =
                        snap.selectList[storeKey].map((item) =>
                          item.id === id
                            ? { ...item, checked: e.target.checked }
                            : item
                        );
                    }}
                    style={{ marginRight: "7px" }}
                  />
                  {name} ({scacCode})
                </label>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function AgSelectWithMap({
  label,
  record,
  name,
  dataMap,
  callback = (selectedValue) => selectedValue,
  isValid = true,
  validationMsg,
}) {
  const imRecord = useSnapshot(record);
  return (
    <div className="field">
      <label className="label is-small" style={{ marginBottom: "0px" }}>
        {label}
      </label>
      <div className="control">
        <div
          className={isValid ? "select is-small" : "select is-small is-danger"}
        >
          <select
            name={name}
            value={imRecord[name]}
            onChange={(e) => {
              record[name] = e.target.value;
              callback(e.target.value);
            }}
          >
            <option selected value={""} hidden>
              Select an option
            </option>
            {dataMap.map(({ key, value }) => (
              <option value={value}>{key}</option>
            ))}
          </select>
        </div>
      </div>
      {
        (name=="carrier" && imRecord[name].length>0 && !isValid)?<p class="help is-danger">
        {" "}
        {"- Please pick different carrier"}
      </p>:<>
      {!isValid && (
        <p class="help is-danger">
          {" "}
          {validationMsg || `* Please select valid ${label}`}
        </p>
      )}
      </>
      }
    </div>
  );
}

export function AgSelectWithMap1({
  label,
  record,
  name,
  dataMap,
  callback = (selectedValue) => selectedValue,
  isValid = true,
  validationMsg,
}) {
  const imRecord = useSnapshot(record);
  return (
    <div className="field">
      <label className="label is-small" style={{ marginBottom: "0px" }}>
        {label}
      </label>
      <div className="control">
        <div
          className={isValid ? "select is-small" : "select is-small is-danger"}
        >
          <select
            name={name}
            value={imRecord[name]}
            onChange={(e) => {
              record[name] = e.target.value;
              callback(e.target.value);
            }}
          >
            {/* <option selected value={""} hidden>
              Select an option
            </option> */}
            {dataMap.map(({ key, value }) => (
              <option value={value}>{key}</option>
            ))}
          </select>
        </div>
      </div>
      {!isValid && (
        <p class="help is-danger">
          {" "}
          {validationMsg || `* Please select valid ${label}`}
        </p>
      )}
    </div>
  );
}

export function TableEditWithValue(props) {
  const {
    record,
    name,
    type = "text",
    tabIndex = "0",
    isreadonly = false,
    callback = (f) => f,
    isValid = true,
    isDisabled,
  } = props;
  const imRecord = useSnapshot(record);
  return (
    <div className="control is-fullwidth is-small">
      <input
        style={{ backgroundColor: "white", color: "black" }}
        {...props}
        value={record[name]}
        type={type}
        name={name}
        defaultValue={record[name]}
        onChange={(e) => {
          record[name] = e.target.value;
          callback(e.target.value);
        }}
        className={isValid ? "input is-small" : "input is-small is-danger"}
        inputmode={type}
        {...isDisabled}
        readOnly={isreadonly}
      />
    </div>
  );
}

export function AgWarnPopup({
  callback = (f) => f,
  onClose,
  acceptBtnText = `Accept`,
  ...props
}) {
  useSnapshot(configStore);
  return (
    <div class={configStore.hasToShowAgWarn ? "modal is-active" : "modal"} style={{zIndex:100}}>
      <div class="modal-background"></div>
      <div class="modal-content">
        <article class="message is-warning">
          <div class="message-body">
            {props.children}
            <div
              className="buttons"
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <button
                type="button"
                className="button is-danger is-small"
                onClick={() => (configStore.hasToShowAgWarn = false)}
              >
                Close
              </button>
              <button
                type="button"
                className="button is-warning is-small"
                onClick={() => {
                  callback();
                  configStore.hasToShowAgWarn = false;
                  props.data()
                }}
              >
                {acceptBtnText}
              </button>
            </div>
          </div>
        </article>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        onClick={() => (configStore.hasToShowAgWarn = false)}
      >
        Close
      </button>
    </div>
  );
}

export function AgWarnPopup1({
  callback = (f) => f,
  onClose,
  acceptBtnText = `Confirm`,
  ...props
}) {
  useSnapshot(configStore);
  useSnapshot(taskStore)
  useSnapshot(bookingsStore)
  useSnapshot(entityStore)
  return (
    <div class={configStore.hasToShowAgWarn ? "modal is-active" : "modal"}>
      <div class="modal-background"></div>
      <div class="modal-content">
        <article class="message is-warning">
          <div class="message-body">
            {props.children}
            <div
              className="buttons"
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <button
                type="button"
                className="button is-danger is-small"
                onClick={() => (configStore.hasToShowAgWarn = false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="button is-warning is-small"
                onClick={async (e) => {
                  configStore.hasToShowAgWarn = false;
                  let booking = bookingsStore.current
                  let pendingCheck = false
                    let actions = await MonApi.apost(GET_PENDING_MYACTIONS_URI, {
  bookingNum: booking._id
});
                    if((actions?.length > 0 && actions.every(e=>e.pendingWith == process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase())) || actions.length==0){
                      let dsr = await MonApi.apost(GET_BOOKINGDSR_BY_FILTER_URI, {
  _id: booking._id
})
                      if(dsr.length > 0){
                        dsr = dsr[0]
                        if(!dsr.tsUpdatedOn){
                            await MonApi.apost(UPDATE_BOOKING_CANCELLED_URI, {
  '_id': booking?._id
})
                          if(booking?.contract?.isCarting == 'Yes' || booking?.linkedCarting?.length > 0){
                            CartingOrderApi.revertCartingBooking(booking)
                          }
                          if (taskStore.current?.bookingNum != undefined || booking?._id != undefined) {
                            await MonApi.apost(REMOVE_MYACTIONS_BY_BOOKING_NUMBER_AND_STATUS_URI, {
                              bookingNum: taskStore.current?.bookingNum || booking?._id,
                              status: 'PENDING'
                            })
                          }
                        }else{
                          pendingCheck = true
                        }
                      }
                    }else{
                      pendingCheck = true
                    }
                    if(pendingCheck){
                      taskStore.current = new Task('')
                  taskStore.current.initialize(bookingsStore.current, entityStore.entityRec)
                  taskStore.current.actionName = "Request for Booking Cancellation"
                  Object.assign(taskStore.current, getPayload("Request for Booking Cancellation"))
                  taskStore.current.reason = bookingsStore.requestCancellationReason
                  taskStore.current.entityId=bookingsStore.current.contract.entityId
                  taskStore.current.branchId=bookingsStore.current.branchId
                  // taskStore.setCustomerComplete()
                  taskStore.current.stage = 1
                  taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                  taskStore.name = "Request for Booking Cancellation"
                  taskStore.oldtask = JSON.parse(JSON.stringify(taskStore.current))
                  await Taskapi.saveTask(taskStore.current)
                  callback();

                    }
                }}
              >
                {acceptBtnText}
              </button>
            </div>
          </div>
        </article>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        onClick={() => (configStore.hasToShowAgWarn = false)}
      >
        Close
      </button>
    </div>
  );
}

export function AgTextShow({ label, value }) {
  return (
    <div className="field">
      <label className="label is-small" style={{ marginBottom: "0px" }}>
        {label}
      </label>
      <div className="control is-fullwidth">
        <p className="is-size-7">{value}</p>
      </div>
    </div>
  );
}
